import React from "react";
import { resolveRecipientRoleIds } from "../../../services/lookupService";
import { resolveDefaultPiRoleId } from "./isfMilestoneService";
import MilestoneRecipientRoles from "./MilestoneRecipientRoles";

const MilestoneWorkflowRoles = ({
  form,
  setForm,
  errors = {},
  readOnly = false,
  notificationRoles = [],
  onSetUploaderRoles,
  onSetSignerRoles,
  compact = false,
  showTitle = true,
}) => (
  <div className={compact ? "milestone-workflow-roles milestone-workflow-roles--compact" : "milestone-workflow-roles"}>
    {showTitle && !compact && <h6>Workflow roles</h6>}
    {showTitle && compact && (
      <h6 className="milestone-detail-sidebar__title">Signature &amp; workflow</h6>
    )}
    <label className="milestone-modal-label">
      Uploader role(s) <span className="mandatory">*</span>
    </label>
    <MilestoneRecipientRoles
      selectedRoleIds={resolveRecipientRoleIds(form.DefaultUploaderRoles, notificationRoles)}
      allRoles={notificationRoles}
      disabled={readOnly}
      showSearch
      excludeSelectedFromPicker
      onChange={onSetUploaderRoles}
    />
    {errors.DefaultUploaderRoles && (
      <small className="text-danger d-block">{errors.DefaultUploaderRoles}</small>
    )}
    <div className="form-check form-switch mt-3 mb-2">
      <input
        className="form-check-input"
        type="checkbox"
        id={compact ? "milestone-detail-requires-signature" : "milestone-requires-signature"}
        disabled={readOnly}
        checked={!!form.RequiresSignature}
        onChange={(e) =>
          setForm((p) => ({
            ...p,
            RequiresSignature: e.target.checked,
            DefaultSignerRoles: e.target.checked
              ? p.DefaultSignerRoles ||
                resolveDefaultPiRoleId(notificationRoles) ||
                ""
              : "",
          }))
        }
      />
      <label
        className="form-check-label"
        htmlFor={compact ? "milestone-detail-requires-signature" : "milestone-requires-signature"}
      >
        Requires signature
      </label>
    </div>
    {form.RequiresSignature && (
      <>
        <label className="milestone-modal-label">Signer role(s)</label>
        <MilestoneRecipientRoles
          selectedRoleIds={resolveRecipientRoleIds(form.DefaultSignerRoles, notificationRoles)}
          allRoles={notificationRoles}
          disabled={readOnly}
          showSearch
          excludeSelectedFromPicker
          onChange={onSetSignerRoles}
        />
        {errors.DefaultSignerRoles && (
          <small className="text-danger d-block">{errors.DefaultSignerRoles}</small>
        )}
      </>
    )}
  </div>
);

export default MilestoneWorkflowRoles;
